// import React, { useState, useEffect } from "react";
// import "./PST_Spotlight.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

// import { useDispatch, useSelector } from "react-redux";
// import { AllSpotLight } from "../../../features/admin/common/Slice";
// import { IDS } from "../../../utils/IDS";

// const PST_Spotlight = () => {
//   const images = [
//     "/assets/images/home/PST_Spotlight/img-1.png",
//     "/assets/images/home/PST_Spotlight/img-2.png",
//     "/assets/images/home/PST_Spotlight/img-1.png",
//     "/assets/images/home/PST_Spotlight/img-2.png",
//   ];

//   const [activeIndex, setActiveIndex] = useState(0);

//   const nextSlide = () => {
//     setActiveIndex((prev) => (prev + 1) % images.length);
//   };

//   const prevSlide = () => {
//     setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//   };

//   // arrange stacked order
//   const getIndex = (index) => {
//     return (index - activeIndex + images.length) % images.length;
//   };

//   const dispatch = useDispatch();
//   const spotlight = useSelector((state) => state.common.all_spotlight);

//   useEffect(() => {
//     dispatch(AllSpotLight());
//   }, [dispatch]);

//   return (
//     <section className="PST_Spotlight">
//       <div className="container">
//         <div className="PST_Spotlight_header">
//           <h5 className="spotlight_title">
//             PST Academy In <span>Spotlight</span>
//           </h5>
//           <span>
//             <img
//               src="/assets/images/home/PST_Spotlight/title-img.png"
//               alt="title-img"
//               className="title_img"
//             />
//           </span>
//         </div>

//         <div className="image_content_section">
//           <div className="row justify-content-center">
//             <div className="col-lg-5 col-md-6 col-sm-5">
//               <div className="image_stack">
//                 {spotlight.map((item, index) => {
//                   const position = getIndex(index);
//                   return (
//                     <div
//                       key={item.id}
//                       className={`stack_image position_${position}`}
//                     >
//                       <img
//                         src={`${IDS.IMG_URL}${item.image}`}
//                         alt={item.title}
//                         className="stack_img"
//                       />
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             <div className="col-lg-5 col-md-6 col-sm-7">
//               <div className="content_area">
//                 <h2 className="content_title">
//                   {spotlight[activeIndex].title}{" "}
//                 </h2>
//                 <p className="content_text">{spotlight[activeIndex].description}</p>

//                 <div className="arrow_controls">
//                   <div className="arrow_holder" onClick={prevSlide}>
//                     <FontAwesomeIcon
//                       icon={faArrowLeft}
//                       style={{ color: "#093D5D" }}
//                     />
//                   </div>
//                   <div className="arrow_holder" onClick={nextSlide}>
//                     <FontAwesomeIcon
//                       icon={faArrowRight}
//                       style={{ color: "#093D5D" }}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PST_Spotlight;

import React, { useState, useEffect } from "react";
import "./PST_Spotlight.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { useDispatch, useSelector } from "react-redux";
import { AllSpotLights } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const PST_Spotlight = () => {
  const dispatch = useDispatch();
  const spotlight = useSelector((state) => state.common.all_spotlight || []);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    dispatch(AllSpotLights());
  }, [dispatch]);

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % spotlight.length);
  };

  const prevSlide = () => {
    setActiveIndex((prev) => (prev === 0 ? spotlight.length - 1 : prev - 1));
  };

  // calculate position for stacked images
  const getIndex = (index) => {
    return (index - activeIndex + spotlight.length) % spotlight.length;
  };

  if (!spotlight.length) return null; // optional: render nothing until data loads

  return (
    <section className="PST_Spotlight">
      <div className="container">
        <div className="PST_Spotlight_header">
          <h5 className="spotlight_title">
            PST IT Solutions In <span>Spotlight</span>
          </h5>
          <span>
            <img
              src="/assets/images/home/PST_Spotlight/title-img.png"
              alt="title-img"
              className="title_img"
            />
          </span>
        </div>

        <div className="image_content_section">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-6 col-sm-5">
              <div className="image_stack">
                {spotlight.map((item, index) => {
                  const position = getIndex(index);
                  return (
                    <div
                      key={item.id}
                      className={`stack_image position_${position}`}
                    >
                      <img
                        src={`${IDS.IMG_URL}${item.image}`}
                        alt={item.title}
                        className="stack_img"
                      />
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="col-lg-5 col-md-6 col-sm-7">
              <div className="content_area">
                <h2 className="content_title">
                  {spotlight[activeIndex].title}
                </h2>
                <p className="content_text">
                  {spotlight[activeIndex].description}
                </p>

                <div className="arrow_controls">
                  <div className="arrow_holder" onClick={prevSlide}>
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      style={{ color: "#093D5D" }}
                    />
                  </div>
                  <div className="arrow_holder" onClick={nextSlide}>
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      style={{ color: "#093D5D" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PST_Spotlight;